<div [ngStyle]="getTextStyles()">
  <quill-editor *ngIf="quillInited$ | async; else loadingModules" i18n-placeholder="text-element|placeholder"
    placeholder="Insert text here ..." [modules]="staticQuillConfig" [readOnly]="setAsReadOnly$ |async"
    [(ngModel)]="block.innerText" (onContentChanged)="contentChanged()">
  </quill-editor>
</div>

<ng-template #loadingModules>
  <span i18n="text-element|loading message">Please wait ...</span>
</ng-template>